/** @jsx jsx */
import { Flex, Heading, Paragraph, UserAvatar } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { Comment } from "@/components/comments/Comment";
import { JobApplication } from "@/data/job-applications/types/JobApplication";
import { useFormats } from "@/hooks/Formats";
import { JobApplicationStatusComponent } from "@/views/job-applications/status/JobApplicationStatusComponent";

interface JobApplicationDetailsDecisionProps {
  jobApplication: JobApplication;
}

export const JobApplicationDetailsDecision: FC<JobApplicationDetailsDecisionProps> = ({ jobApplication }) => {
  const { t } = useTranslation("session");

  const { formatDateTime } = useFormats();

  return (
    <Flex gap="sm" flexDirection="column">
      <Flex justifyContent="space-between" alignItems="center">
        <Heading size="h-sm">{t("JOB_APPLICATIONS.DETAIL.DECISION")}</Heading>
        <JobApplicationStatusComponent status={jobApplication.status} />
      </Flex>

      <Comment>
        <Flex gap="xs" alignItems="center">
          {jobApplication.comment?.authorFirstName && jobApplication.comment?.authorLastName && (
            <UserAvatar
              size="xs"
              firstName={jobApplication.comment.authorFirstName}
              lastName={jobApplication.comment.authorLastName}
            />
          )}
          <Paragraph bold>
            {jobApplication.comment?.authorFirstName} {jobApplication.comment?.authorLastName}
          </Paragraph>
          <Paragraph color="n700">{formatDateTime(jobApplication.comment?.commentCreatedDate)}</Paragraph>
        </Flex>
        <Paragraph>{jobApplication.comment?.externalComment}</Paragraph>
      </Comment>
    </Flex>
  );
};
